module.exports = __webpack_public_path__ + "img/badge_salabam_voli.59c65834.jpg";